import classNames from 'classnames'

export function SnackbarMessage({ className, ...rest }) {
  return <span {...rest} className={classNames('SnackbarMessage', className)} />
}
